import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import { status } from "@/utils/common";

export default {
    namespaced: true,
    state: {
        invoices: [],
        invoice: {
            id: null,
            invoiceNo: null,
            services: [],
            analyses: [],
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.invoices.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.invoices = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.invoice = viewData,
        ADD: (state, addedData) => state.invoices.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.invoices.splice(index, 1, updateData),
        DELETE: (state, index) => state.invoices.splice(index, 1),
        cancel: (state, index) => state.invoices[index].status = status.cancel,
        approval: (state, index) => state.invoices[index].status = status.active,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");
                const response = await dataService.invoicesAnalysis.getAll(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.invoices);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_ITEM', {});
                const response = await dataService.invoicesAnalysis.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEM', response.data.invoice);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForEdit(_, id) {
            startLoading()
            try {

                const response = await dataService.invoicesAnalysis.getForEdit(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.invoice);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getAppointments(_, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.invoicesAnalysis.getAppointments(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.appointments);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForPrint(_, id) {
            startLoading()
            try {
                const response = await dataService.invoicesAnalysis.getForPrint(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.invoice);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add({ commit }, payload) {
            try {
                startLoading()
                const response = await dataService.invoicesAnalysis.add(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);
                commit("ADD", response.data.invoice);


            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },

        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.invoicesAnalysis.edit(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.invoice });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.invoicesAnalysis.delete(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async approval({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.invoicesAnalysis.approval(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                const index = getters.index(id);
                commit("approval", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);

            }
        },


        async addPatient(_, payload) {
            startLoading()
            try {
                const response = await dataService.patients.add(payload);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data);
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async cancel({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.invoicesAnalysis.cancel(id);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('cancel', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        // ------------------------------------------------------------ //
        async search(_, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");
                const response = await dataService.invoicesAnalysis.search(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },

    },
};
